const { render } = wp.element;
import {
    BrowserRouter,
    Routes,
    Route,
    useNavigate,
    Outlet
} from 'react-router-dom';
import './view.scss';

const App = ({ basename, wp_params }) => {
    return (
        <BrowserRouter basename={basename}>
            <AppRoutes {...wp_params} />
        </BrowserRouter>
    );
};

// 3. Tus rutas de React
const AppRoutes = (props) => {
    const navigate = useNavigate();

    const go = (path) => {
        navigate(path);
    };

    return (
        <div className="APP">
            <div class="comment">
                En este bloque se procesan las subrutas con el router interno
                del <strong>view.js</strong> del bloque sin recarga de página ni
                # (BrowserRouter). No es necesario config de server.
            </div>
            <div className="wp-params">Parámetros de la ruta de la página</div>
            <div className="params">
                {Object.keys(props).map((key) => (
                    <div className="param">
                        <div className="key">{key}</div>
                        <div className="equal">=</div>
                        <div className="value">{props[key]}</div>
                    </div>
                ))}
            </div>
            <div className="menu">
                <div className="option" onClick={() => go('/')}>
                    Block Root
                </div>
                <div className="option" onClick={() => go('/a')}>
                    a
                </div>
                <div className="option" onClick={() => go('/b')}>
                    b
                </div>
                <div className="option" onClick={() => go('/c')}>
                    c
                </div>
            </div>
            <Routes>
                <Route
                    path="/"
                    element={<div className="content root">Root</div>}
                />
                <Route
                    path="/a"
                    element={
                        <div className="content a">
                            <div className="text">
                                Ruta A<a onClick={() => go('/a/b')}>a / B</a>
                            </div>
                            <Outlet />
                        </div>
                    }
                >
                    <Route
                        path="b"
                        element={
                            <div className="content a">
                                <div className="text">Ruta A/B</div>
                            </div>
                        }
                    ></Route>
                </Route>
                <Route
                    path="/b"
                    element={
                        <div className="content b">
                            <div className="text">Ruta B</div>
                        </div>
                    }
                />
                <Route
                    path="/c"
                    element={
                        <div className="content c">
                            <div className="text">Ruta C</div>
                        </div>
                    }
                />
                <Route
                    path="*"
                    element={
                        <div className="content no-encontrada">
                            <div className="text">No encontrada</div>
                            <div className="back" onClick={() => go('/')}>
                                root
                            </div>
                        </div>
                    }
                />
            </Routes>
        </div>
    );
};

// 4. Lógica de montaje (el "puente" con el DOM de WordPress)
document.addEventListener('DOMContentLoaded', () => {
    const container = document.querySelector(
        '.wp-block-playmotiv-theme-player-base'
    );

    if (container && container.dataset.config) {
        const config = JSON.parse(container.dataset.config);
        console.log(config);

        render(<App {...config} />, container);
    }
});
